import * as React from 'react';
import { BreakpointConfigType } from '../../constants/types';
import { GridContextProps, withGridContext } from '../grid/GridContext';
import { StyledColumnDiv } from './styledColumnDiv';

export interface ColumnProps {
  span: BreakpointConfigType | number;
  offset?: number;
}

const Column: React.SFC<ColumnProps & GridContextProps> = ({ children, grid, offset, span }) => {
  return (
    <StyledColumnDiv
      span={span}
      offset={offset}
      grid={grid}
    >
      {children}
    </StyledColumnDiv>
  );
};

export default withGridContext(Column);
